/*
 * @Author: yanghailong 
 * @Date: 2023-08-23 09:06:42 
 * @Last Modified by:   yanghailong 
 * @Last Modified time: 2023-08-23 09:06:42 
 */
class _History {
    constructor(topology) {
        // this.topology = topology
        this.undos = []
        this.redos = []
        this.historyDisabled = false
    }

    push(cmd) {
        if (this.undos.length > 20) {
            this.undos.shift()
        }
        this.undos.push(cmd)
    }

    undo() {
        if (this.historyDisabled) {
            alert('Undo/Redo disabled')
            return
        }
        let cmd
        if (this.undos.length > 0) {
            cmd = this.undos.pop()
            // 从json中读取，渲染
        }
        if (cmd != null) {
            cmd.undo()
            this.redos.push(cmd)
        }
        return cmd
    }

    redo() {
        if (this.historyDisabled) {
            alert('Undo/Redo disabled')
            return
        }
        let cmd
        if (this.redos.length > 0) {
            cmd = this.redos.pop()
            // 从json中读取，渲染
        }
        if (cmd != null) {
            // 执行命令
            cmd.execute()
            this.undos.push(cmd)
        }

        return cmd
    }
}


export { _History }
